import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import appReducer from "../slice/app";
import userReducer from "../slice/user";
import fxListReducer from "../slice/fx";
import watchlistReducer from "../slice/watchlist";
import newsReducer from "../slice/news";
import errorTimeoutReducer from "../slice/errorTimeout";

export const store = configureStore({
	reducer: {
		app: appReducer,
		user: userReducer,
		fx: fxListReducer,
		watchlist: watchlistReducer,
		news: newsReducer,
        errorTimeout: errorTimeoutReducer
	},
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
